import React from 'react';
import { useHistory } from 'react-router-dom';
import { pathname } from '../../utils/path/path';
import { applicationStatus } from '../../utils/enums';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import ExpandRow from '../misc/ExpandTableRow';
import Container from '@material-ui/core/Container';
import Summary from './Summary';
import Link from '@material-ui/core/Link';

const useStyles = makeStyles((theme: any) => ({
  root: { maxWidth: 600, color: theme.palette.lightBlack },
  message: { marginTop: theme.spacing(2) },
  deleteButton: { cursor: 'pointer' },
}));

export default function Expanded({
  plan,
  numColumns,
  deletePlan,
  openContract,
  openContractAddendum,
  rejectEditedPlan,
}) {
  const classes = useStyles();
  const history = useHistory();

  const showPlanSummary = [
    applicationStatus.complete.status,
    applicationStatus.active.status,
    applicationStatus.pending.status,
  ];

  return (
    <React.Fragment>
      <ExpandRow numberOfColumns={numColumns} expanded={plan.expanded}>
        <Container className={classes.root}>
          {showPlanSummary.includes(plan?.status) && (
            <Summary
              plan={plan}
              openContract={openContract}
              openContractAddendum={openContractAddendum}
              rejectEditedPlan={rejectEditedPlan}
            />
          )}
          {[
            applicationStatus.submitted.status,
            applicationStatus.review.status,
          ].includes(plan?.status) && (
            <>
              <Typography
                variant="body1"
                align="center"
                paragraph
                className={classes.message}
              >
                Our team is working on your Growth Plan. Check back soon!
              </Typography>
              <Typography
                variant="body1"
                align="center"
                paragraph
                className={classes.message}
              >
                What Lines are in this Plan?{' '}
                <Link
                  color="primary"
                  className={classes.deleteButton}
                  underline="none"
                  onClick={() =>
                    history.push(pathname.lines.url + `?plan=${plan?.id}`)
                  }
                >
                  See Lines {'>'}
                </Link>
              </Typography>
              {!plan.originApplication && (
                <Typography
                  variant="body1"
                  align="center"
                  paragraph
                  className={classes.message}
                >
                  Need to make a change?{' '}
                  <Link
                    color="primary"
                    className={classes.deleteButton}
                    underline="none"
                    onClick={() => deletePlan(plan)}
                  >
                    Return to Draft {'>'}
                  </Link>
                </Typography>
              )}
            </>
          )}
          {(plan?.status === applicationStatus.archived.status ||
            plan?.status === applicationStatus.rejected.status) && (
            <Typography
              variant="body1"
              align="center"
              paragraph
              className={classes.message}
            >
              This Growth Plan was not activated. If you have questions, please
              contact us.
            </Typography>
          )}
        </Container>{' '}
      </ExpandRow>
    </React.Fragment>
  );
}
